// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "crew-96df2.firebaseapp.com",
  "projectId": "crew-96df2",
  "storageBucket": "crew-96df2.appspot.com",
  "messagingSenderId": "256660086961",
  "appId": "1:256660086961:web:2cb3ce97cc6d5c382c4290",
  "measurementId": "G-WRV13T6HN7",
  "apiKey": "AIzaSyDZj4iWySW-_qCSZC8gbBgMxslyeN3uAYM"
};
